// extracted by mini-css-extract-plugin
export var formContainer = "_ek-0";
export var message = "_ek-1";